var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){

   Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = ['https://cdn.shopify.com/s/files/1/0628/6072/2411/files/free-shipping.png?v=1673798025',  
'https://cdn.shopify.com/s/files/1/0628/6072/2411/files/return-policy.png?v=1673798026', 
'https://cdn.shopify.com/s/files/1/0628/6072/2411/files/secure-checkout.png?v=1673798026'];
var badgeTexts = ["Free Shipping on Orders $90+",
                  "Easy Return Policy",
                  "Secure Checkout"];
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.product-single__form')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container"><img src="' + imgSrcs[i] +  '"><span class="badge'+i+'">'+badgeTexts[i]+'</span></div>';
    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
}  
   
 if(jQuery('.mon-buyNow').length == 0){
     jQuery('button.btn.btn--full.add-to-cart.btn--secondary').eq(0).after(jQuery('<div class="mon-buyNow">BUY NOW</div>'));



  jQuery('.mon-buyNow').click(function(){
    var b = 0;
var timerb = setInterval(function(){
  if(jQuery('.shopify-payment-button__more-options').eq(0).length || b > 200) {
	 jQuery('.shopify-payment-button__more-options').eq(0).click();;
     clearInterval(timerb);
  }
b++;
}, 50);
  });
 }


}); 
}




var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
    
  var btnClass = "button.btn.btn--full.add-to-cart.btn--secondary";
  var selectorClass = ".variant-input-wrap";

    
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"></div><div class="simple-product-price"></div></div> <div class="simple-st-container__inner"> <div class="simple-select-container"> <div class="simple-st-select" id="st-select0"> <span>Color</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select1"> <span>Type</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select2"> <span>Type</span> <select> <option></option> </select> </div></div><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('simple-st-container').length == 0){
  y[0].appendChild(sticky);
  
  
jQuery('.simple-product-name').html(jQuery('.product-single__title').eq(0).html());
  
 
function populateOptions(select, labels){
  var selected = labels.eq(0).prop('selectedIndex');
  labels = labels.eq(0).find('label');
  for(var i =0; i < labels.length; i++){
      var option = document.createElement('OPTION');
    
      var t = document.createTextNode(labels.eq(i).html());
      option.appendChild(t);
   	  option.id = i;
      select.appendChild(option);
    
    	if(i ==0){
          select.removeChild(select.firstElementChild);
          
          
        }
    
  }
  
  select.selectedIndex = selected;
}
  
  jQuery('.simple-st-item__button').click(function(){
   if(!jQuery('.simple-st-item__button').hasClass("simple-st-disabled")){
     
      jQuery(btnClass).eq(0).click();
     $('html, body').animate({
        scrollTop: $('.payment-buttons').offset().top
    }, 0);
      }
    
   
  });
  
 if(jQuery(selectorClass).eq(0).length >= 1){
 
   jQuery('.simple-st-select span').eq(0).html(jQuery('label.variant__label').eq(0).html());
  jQuery('#st-select0').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select0').getElementsByTagName('select')[0], jQuery(selectorClass));
}
    
  
 if(jQuery(selectorClass).eq(1).length >= 1){
 
   jQuery('.simple-st-select span').eq(1).html(jQuery(selectorClass).eq(1).find('label').eq(0).html());
  jQuery('#st-select1').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select1').getElementsByTagName('select')[0], jQuery(selectorClass + ' select'));
}
    
    
    
};
  
     function checkIfDisabled() {
         setTimeout(function () {
             var elem = jQuery(btnClass + ' span').eq(0);
             jQuery('.simple-st-item__button').html(elem.html());
             if (elem.html().trim().toUpperCase() != 'ADD TO CART') {
                 jQuery('.simple-st-item__button').html(elem.html());
                 jQuery('.simple-st-item__button').addClass('simple-st-disabled');
             } else {
                 jQuery('.simple-st-item__button').removeClass('simple-st-disabled');
             }
         }, 100);
     }
 setInterval(function(){ 
    
  checkIfDisabled();
}, 1000);
jQuery('#st-select0 > select').change(function(){
  checkIfDisabled();
  var i = jQuery(this).find(":selected").attr('id');
  jQuery('.variant-input-wrap:eq(0) input').eq(i).click();
 
});

  
jQuery('.variant-input-wrap label').click(function(){
checkIfDisabled();
 jQuery('#st-select0 > select').val(jQuery(this).val());
});
  
    

  
function isVisible(elem){
var elementTop = elem.offset().top;
var elementBottom = elementTop + elem.outerHeight();
var viewportTop = jQuery(window).scrollTop();
var viewportBottom = viewportTop + jQuery(window).height();
return elementBottom > viewportTop && elementTop < viewportBottom;
};
       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("simple-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('simple-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('simple-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery(btnClass).eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
});                             
}

